import React from 'react';

/**
 * CheckOutlined component - An outlined checkmark icon that supports fill and stroke styling
 * @param props - SVG props including width, height, strokeWidth, and other standard SVG attributes
 * @returns SVG element with outlined checkmark path
 */
function CheckOutlined(props: React.SVGProps<SVGSVGElement>) {
  const {
    width = 24,
    height = 24,
    strokeWidth = 2,
    ...rest
  } = props;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default CheckOutlined;
